import "babel-polyfill";
// import "./libs/jquery";
import "./libs/slickSlider";
import "./libs/jcf/jcf.js";
import "./libs/jcf/jcf.scrollable.js";
import "./libs/jcf/jcf.select.js";
// import "slick-carousel";


import {binder, fwa} from "./libs/binder";
import {constants} from "./modules/module";
import {fullHeight} from "./modules/fullHeight";
import {addNavSticky} from "./modules/addNavSticky";
import {customSelect} from "./modules/customSelect";
import {navFunction} from "./modules/navFunction";
import {disclosureMenu} from "./modules/disclosureMenu";
import {navFunctionADA} from "./modules/navFunctionADA";
// import {headerLogInADA} from "./modules/headerLogInADA";
import {mainSlider} from "./modules/main-slider";
import {insightsSlider} from "./modules/insights-slider";
import {cookieInfo} from "./modules/cookieInfo";
import {offersNav} from "./modules/offersNav";
import {scrollTop} from "./modules/scrollTop";
import {skipContent} from "./modules/skipContent";
import {keyMilestones} from "./modules/keyMilestones";
import {tabs} from "./modules/tabs";
import {accordion} from "./modules/accordion";
import {popupBio} from "./modules/popupBio";
import {printArticle} from "./modules/printArticle";
import {stickySharing} from "./modules/stickySharing";
import {industriesSlider} from "./modules/industriesSlider";
import {keyFeaturesAnimate} from "./modules/keyFeaturesAnimate";
import {accountDetailsTable} from "./modules/accountDetailsTable";
import {contentVideo} from "./modules/contentVideo";
import {exchangeRates} from "./modules/exchangeRates";
import {globalReach} from "./modules/globalReach";
import {openHours} from "./modules/openHours";
import {photoOnResize} from "./modules/photoOnResize";
import {urgentMessage} from "./modules/urgentMessage";
import {introAddNavSticky} from "./modules/introAddNavSticky";
import {buttonOrder} from "./modules/buttonOrder";
import {footerWechat} from "./modules/footerWechat";
import {videoPopupOpener} from "./modules/videoPopupOpener";
import {footer} from "./modules/footer";
import {tabsADA} from "./modules/tabsADA";
import {cookiePopup} from "./modules/cookiePopup";
import {targetedNoticesSlider} from "./modules/targeted-notices-slider";


binder({
    bounds: {
        "html": [constants, fullHeight, cookiePopup],
        "select,.jcf-scrollable": customSelect,
        ".header": [navFunction, disclosureMenu],
        ".main-add-menu": addNavSticky,
        "body": cookieInfo,
        ".main-slider": mainSlider,
        ".insights .slider": insightsSlider,
        ".offers-nav": offersNav,
        ".scroll-to-top": scrollTop,
        ".skip-content": skipContent,
        ".key-milestones": keyMilestones,
        ".accordion, .faq-accordion, .accounts-list": accordion,
        ".tab-nav": tabs,
        ".popup-bio": popupBio,
        ".print-ico": printArticle,
        ".sharing": stickySharing,
        ".industries": industriesSlider,
        ".key-features": keyFeaturesAnimate,
        ".account-details-table": accountDetailsTable,
        ".video-holder": contentVideo,
        ".exchange-table": exchangeRates,
        ".global-reach svg": globalReach,
        ".bank-status": openHours,
        ".photo-on-resize": photoOnResize,
        ".header-urgent-message": urgentMessage,
        ".intro-page.sticky-nav": introAddNavSticky,
        ".latest-news .container >.button,.insights .container .button": buttonOrder,
        ".footer .wechat-link": footerWechat,
        ".video-popup-opener": videoPopupOpener,
        ".footer": footer,
        "[role=tab]": tabsADA,
        ".targeted-notices-nav-slider": targetedNoticesSlider
    },
    runTests: false
});



// WEBPACK FOOTER //
// ./assets/js/global.js